// LoadingState — skeleton shimmer placeholders for the three load contexts
// flagged in PHASE9 §2.22:
//   - 'app'      : full-screen boot before auth/projects resolve
//   - 'grid'     : CapturesGrid image cells while captures fetch
//   - 'kanban'   : 4-column card stack while remarks fetch
//
// Pure CSS shimmer (keyframe in main.css). Stays inert when nothing is loading.

import { For } from 'solid-js';

interface SkeletonProps {
  variant: 'app' | 'grid' | 'kanban';
}

export function LoadingState(props: SkeletonProps) {
  if (props.variant === 'app') {
    return (
      <div class="skeleton-app" aria-busy="true" aria-label="Chargement…">
        <div class="skeleton-block skeleton-shimmer" style={{ width: '180px', height: '24px' }} />
        <div class="skeleton-block skeleton-shimmer" style={{ width: '280px', height: '14px' }} />
        <div class="skeleton-block skeleton-shimmer" style={{ width: '220px', height: '14px' }} />
      </div>
    );
  }

  if (props.variant === 'grid') {
    return (
      <div class="skeleton-grid" aria-busy="true" aria-label="Chargement des captures…">
        <For each={[0, 1]}>
          {() => (
            <div class="skeleton-grid-cell">
              <div class="skeleton-block skeleton-shimmer skeleton-grid-header" />
              <div class="skeleton-block skeleton-shimmer skeleton-grid-image" />
            </div>
          )}
        </For>
      </div>
    );
  }

  // kanban
  return (
    <div class="skeleton-kanban" aria-busy="true" aria-label="Chargement du kanban…">
      <For each={[0, 1, 2, 3]}>
        {() => (
          <div class="skeleton-kanban-col">
            <div class="skeleton-block skeleton-shimmer skeleton-kanban-header" />
            <For each={[0, 1, 2]}>
              {() => <div class="skeleton-block skeleton-shimmer skeleton-kanban-card" />}
            </For>
          </div>
        )}
      </For>
    </div>
  );
}
